import { Button, Space, Spin, Typography } from 'antd';
import { QrcodeOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface NfcScanOverlayProps {
  open: boolean;
  onClose: () => void;
  isScanning?: boolean;
  error?: string | null;
}

/**
 * Full-screen overlay hiển thị khi POS ở chế độ chờ quét NFC (F2).
 * ESC hoặc click "Huỷ" để thoát.
 */
export function NfcScanOverlay({ open, onClose, isScanning = true, error }: NfcScanOverlayProps) {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.6)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      data-testid="pos-nfc-scan-overlay"
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: 40,
          maxWidth: 420,
          textAlign: 'center',
        }}
      >
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <QrcodeOutlined style={{ fontSize: 72, color: '#a4193d' }} />
          <Title level={3} style={{ margin: 0 }}>
            {error ? 'Không tìm thấy sản phẩm' : 'Đang chờ quét thẻ NFC...'}
          </Title>
          {error ? (
            <Text type="danger">{error}</Text>
          ) : (
            <>
              <Text type="secondary">Đưa thẻ gần đầu đọc NFC để thêm sản phẩm vào giỏ.</Text>
              {isScanning && <Spin />}
            </>
          )}
          <Text type="secondary" style={{ fontSize: 12 }}>
            Nhấn <kbd>ESC</kbd> hoặc bấm Huỷ để thoát.
          </Text>
          <Button onClick={onClose} data-testid="pos-nfc-scan-cancel-btn">
            Huỷ
          </Button>
        </Space>
      </div>
    </div>
  );
}
